<template>

  <div class="container">
    <navBar/>

    <transition :name="routerTransition">

      <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
        <div
          class="content-area__heading"
          :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
          <h2 class="mb-1">Vista Previa</h2>
        </div>

        <!-- BREADCRUMB -->
        <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

      </div>
    </transition>

    <div class="vx-row" v-if="document.attributes">
      <div class="vx-col w-full md:w-full lg:w-2/3 mb-5">
        <ReactPdfViewer
          class="background-fb card-p ovh"
          :pdf="referencePdfUrl || (api_url + document.attributes.download_link)"
          :height="pdfViewerHeight"
        ></ReactPdfViewer>
      </div>

      <div class="vx-col sm:w-full md:w-full lg:w-1/3">
        <vs-card >
          <div class="p-3">
            <h3 class="pb-2"> Resumen del documento</h3>

            <span class="pb-3"> <b>Nombre del documento:</b> <span> {{ this.document.attributes.document_name }}</span></span>
              <div class="py-2 pb-4">
                 <a :href="downloadLink" target="_blank">Descargar documento</a>
              </div>

            <div v-if="!rejectEnable && showSimpleSection">
              <h3 class="pb-2 mt-5">Método Firma Simple</h3>
            </div>
            <div v-if="!rejectEnable && showIdentityButton">
              <p class="mb-4">Si no cuentas con e.firma o FIREL puedes firmar con tu identidad usando una INE.</p>
              <vx-tooltip class="" text="Firma mediante tu Identidad usando tu INE" position="top">
                <vs-button class="w-100 mb-4" color="primary" type="border" @click="toggleTab(9)">Firma Electrónica con identidad</vs-button>
              </vx-tooltip>
            </div>
            <div v-if="!rejectEnable && showSimpleButton">
              <p class="mb-4">Firma con un vídeo y validando tu teléfono (recomendado para extranjeros).</p>
              <vx-tooltip class="" text="Firma simple (para extranjeros)" position="top">
                <vs-button class="w-100 mb-4" color="primary" type="border" @click="toggleTab(10)">Firma Electrónica Simple</vs-button>
              </vx-tooltip>
            </div>
            <div v-if="!rejectEnable && showIdentityButton && showSimpleButton">
              <a target="_blank" href="https://blog.verificamex.com/diferencia-entre-firma-electronica-simple-con-identidad-y-firma-electronica-simple"> <feather-icon icon="HelpCircleIcon" svgClasses="w-4 h-4" /> Conocer las diferencias</a>
            </div>

            <div v-if="!rejectEnable && showAdvancedSection">
              <h3 class="pb-2 mt-5">Método de Firma Avanzada</h3>
              <p class="mb-4">Selecciona el tipo de certificado:</p>
              <vs-button v-if="showEfirmaButton" class="w-100 mb-4" color="primary" type="border" @click="toggleTab(2)">Firmar con e.firma (SAT)</vs-button>
              <vs-button v-if="showFirelButton" class="w-100 mb-4" color="primary" type="border" @click="toggleTab(8)">Firmar con FIREL (PJF)</vs-button>
            </div>

            <div v-if="!rejectEnable">
              <h3 class="pb-2 mt-5 mb-4">No quiero firmar</h3>
              <p class="mb-4">No estoy de acuerdo con lo descrito en el documento, deseo rechazar el la firma.</p>
              <vs-button :color="rejectEnable ? 'warning' : 'danger'" :type="rejectEnable ? undefined : 'border'" @click="rejectEnable = !rejectEnable">
                {{ rejectEnable ? 'Cancelar rechazo' : 'Rechazar documento' }}
              </vs-button>
            </div>
          </div>
        </vs-card>

        <vs-card v-if="rejectEnable">

          <div class="p-3">
            <h4 class="pb-2">Rechazar documento</h4>
            <div>
              <span class="pb-3">No estoy de acuerdo con la firma de este documento.</span>
            </div>
            <div class="pb-3">
              <p >Exposición de motivos:</p>
            </div>

            <quill-editor v-model="reject_motive" :options="editorOptions"></quill-editor>

          <br>
          <div>
            <vs-button :disabled="isSubmitted" ref="loadableButton" id="button-with-loading" class="vs-con-loading__container mr-3" @click="submitReject" color="primary">
              Rechazar
            </vs-button>
            <vs-button :color="rejectEnable ? 'warning' : 'danger'" :type="rejectEnable ? undefined : 'border'" @click="rejectEnable = !rejectEnable">
              {{ rejectEnable ? 'Cancelar rechazo' : 'Rechazar documento' }}
            </vs-button>
          </div>
          </div>
        </vs-card>

      </div>

    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import router from "@/router";
import {API_URL} from "@/config/app";
import navBar from "@/layouts/components/navbar/NavBarHorizontalLayout.vue";
import {ReactInVue} from 'vuera';
import ReactPdfViewer from "../../../../components/viewer-pdf/ReactPdfViewer";
import themeConfig from '@/../themeConfig.js'

export default {
  name: "SignDocument",
  props: ['toggleTab'],
  components: {
    quillEditor,
    navBar,
    'ReactPdfViewer': ReactInVue(ReactPdfViewer)
  },
  data () {
    return {
      isSubmitted: false,
      rejectEnable: false,
      simpleSignatureFeature: false,
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline','strike', 'blockquote'],
            [{'list': 'ordered'}, {'list': 'bullet'}, { 'color': ['red', 'green', 'blue', 'orange', 'violet', '#d0d1d2', 'black'] }],
          ],
        }
      },
      reject_motive: "",
      uuid: "",
      document: {},
      allowSignatureTypes: [],
      identityProviders: [],
      api_url: API_URL,
      windowWidth: window.innerWidth,
      routerTransition  : themeConfig.routerTransition || 'none',
      referencePdfUrl: null,
    }
  },
  computed: {
    downloadLink() {
      if (this.document && this.document.attributes) {
        return this.api_url + this.document.attributes.download_link;
      }
      return '';
    },
    pdfViewerHeight() {
      return this.windowWidth < 992 ? '40vh' : '80vh';
    },
    allowedSignatureMethods() {
      if (!this.document || !this.document.attributes) return [];
      let methods = this.document.attributes.allowed_signature_methods;
      if (typeof methods === 'string') {
        try {
          methods = JSON.parse(methods);
        } catch (e) {
          return [];
        }
      }
      return Array.isArray(methods) ? methods : [];
    },
    hasStrictAllowedMethods() {
      return this.allowedSignatureMethods && this.allowedSignatureMethods.length > 0;
    },
    showIdentityButton() {
      if (this.hasStrictAllowedMethods) {
        return this.allowedSignatureMethods.includes('IDENTITY');
      }
      return (
        this.allowSignatureTypes.includes('VERIFICAMEX') &&
        this.identityProviders.includes('VERIFICAMEX')
      );
    },
    showSimpleButton() {
      if (this.hasStrictAllowedMethods) {
        return this.allowedSignatureMethods.includes('SIMPLE');
      }
      return (
        this.allowSignatureTypes.includes('VERIFICAMEX') &&
        this.identityProviders.includes('LOCAL')
      );
    },
    showEfirmaButton() {
      if (this.hasStrictAllowedMethods) {
        return this.allowedSignatureMethods.includes('EFIRMA');
      }
      return this.allowSignatureTypes.includes('EFIRMA');
    },
    showFirelButton() {
      if (this.hasStrictAllowedMethods) {
        return this.allowedSignatureMethods.includes('FIREL');
      }
      return ['FIREL', 'TEPJF'].every(item => this.allowSignatureTypes.includes(item));
    },
    showSimpleSection() {
      return this.showIdentityButton || this.showSimpleButton;
    },
    showAdvancedSection() {
      return this.showEfirmaButton || this.showFirelButton;
    },
    isAdvancedSignEnable() {
      return this.showAdvancedSection;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    submitReject() {
      this.$store.dispatch("alert/clear", {}, {root:true});
      if (!this.uuid || !this.reject_motive) {
        this.$store.dispatch("alert/error", "Ingrese los datos requeridos");
        return;
      }
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#button-with-loading",
        scale: 0.45
      });
      this.isSubmitted = true;
      this.$store.dispatch("document/reject", {
        uuid: this.uuid,
        motive: this.reject_motive
      }).then(
        () => {
          this.toggleTab(5);
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          this.isSubmitted = false;
        },
        () => {
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          this.isSubmitted = false;
        }
      )
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
  },
  created() {
    let uuid = this.$route.params.uuid
    if (uuid) {
      this.uuid = uuid;
    } else {
      router.push("/");
    }

    this.$store.dispatch("document/getDocumentFromSignature", {uuid: this.uuid})
      .then(
        document => {
          this.document = document;
          console.log(this.document);
          if (document && document.id) {
            this.$store.dispatch("document/getReferenceDocument", { uuid: document.id })
              .then(res => {
                console.log("Respuesta del documento de referencia:", res);
                if (res) {
                  if (res instanceof Blob) {
                    this.referencePdfUrl = URL.createObjectURL(res);
                  } else {
                    let pdfSource = null;
                    if (typeof res === 'string') {
                      pdfSource = res;
                    } else if (res.file) {
                      pdfSource = res.file;
                    } else if (res.data && res.data.attributes && res.data.attributes.file) {
                      pdfSource = res.data.attributes.file;
                    } else if (res.url) {
                      pdfSource = res.url;
                    }

                    if (pdfSource) {
                      if (pdfSource.startsWith('data:application/pdf;base64,') || pdfSource.startsWith('JVBERi')) {
                        let rawB64 = pdfSource;
                        if (pdfSource.startsWith('data:application/pdf;base64,')) {
                          rawB64 = pdfSource.split(',')[1];
                        }
                        try {
                          let blob = this.b64toBlob(rawB64, 'application/pdf');
                          this.referencePdfUrl = URL.createObjectURL(blob);
                        } catch (e) {
                          console.error("Error al convertir base64 a blob", e);
                        }
                      } else {
                        if (pdfSource.startsWith('http://') || pdfSource.startsWith('https://') || pdfSource.startsWith('blob:')) {
                          this.referencePdfUrl = pdfSource;
                        } else {
                          this.referencePdfUrl = this.api_url + (pdfSource.startsWith('/') ? pdfSource : '/' + pdfSource);
                        }
                      }
                    }
                  }
                }
              })
              .catch(err => {
                console.error("Error al obtener el documento de referencia", err);
              });
          }
          let planFeatures = (this.document.attributes && this.document.attributes.plan_features) || [];
          this.simpleSignatureFeature = 
            !planFeatures.length ||
            planFeatures.includes("can_simple_signature") ||
            planFeatures.includes("FIRMA_SIMPLE") ||
            planFeatures.includes("can_simple") ||
            planFeatures.includes("SIMPLE");

          let config = (this.document.attributes && this.document.attributes.config) || {};
          if (typeof config === 'string') {
            try { config = JSON.parse(config); } catch(e) { /* invalid JSON, keep default {} */ }
          }

          if (config && config.allow_type_signatures && config.allow_type_signatures.length) {
            this.allowSignatureTypes = config.allow_type_signatures;
          } else {
            this.allowSignatureTypes = [
              "VERIFICAMEX", 'EFIRMA', 'FIREL', 'TEPJF'
            ];
          }

          if (config && config.identity_providers && config.identity_providers.length) {
            this.identityProviders = config.identity_providers;
          } else {
            this.identityProviders = [
              "VERIFICAMEX"
            ];
          }

          console.log("Configuración procesada en SignDocument.vue:", {
            planFeatures,
            simpleSignatureFeature: this.simpleSignatureFeature,
            allowSignatureTypes: this.allowSignatureTypes,
            identityProviders: this.identityProviders,
            allowedSignatureMethods: this.allowedSignatureMethods,
            hasStrictAllowedMethods: this.hasStrictAllowedMethods,
            showIdentityButton: this.showIdentityButton,
            showSimpleButton: this.showSimpleButton,
            showEfirmaButton: this.showEfirmaButton,
            showFirelButton: this.showFirelButton
          });
          if (this.document.attributes.sign_status === 3 || this.document.attributes.signature_status === 'SIGNED') {
            if (this.document.attributes.redirect_url) {
              this.toggleTab(6, this.document.attributes.redirect_url);
              return;
            }
            this.toggleTab(6, null);
            return;
          }
          if (this.document.attributes.sign_status === 4) {
            this.toggleTab(4, null);
          }
          if (
            this.document.attributes.sign_status !== 3
            && this.document.attributes.sign_status !== 4
            && this.document.attributes.signature_flow_id
          ) {
            if (this.document.attributes.signature_flow_status === 'ERROR') {
              return;
            }
            router.push({name: "page-signature-flow", params: {uuid: this.uuid, signatureFlowId: this.document.attributes.signature_flow_id}})
          }
        },
        () => {
          this.toggleTab(4);
        }
      )
  }
}
</script>

<style scoped lang="scss">
 .ovh{
   overflow: hidden;
 }
</style>
